// test1707
(1707 && 0);
